import React from 'react';

export function GuideLayoutShell({ children }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-16 md:pb-24">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 -mt-12 sm:-mt-16 lg:-mt-20 relative z-20">{children}</div>
    </div>
  );
}

export function GuideMainColumn({ children }) {
  return (
    <article className="lg:col-span-8 bg-surface-container-lowest dark:bg-slate-900/90 rounded-3xl p-6 sm:p-8 md:p-12 shadow-sm border border-outline-variant/15 dark:border-slate-700/80">
      {children}
    </article>
  );
}

export function GuideAsideColumn({ children }) {
  return <aside className="lg:col-span-4 space-y-8">{children}</aside>;
}

export default GuideLayoutShell;
